import React from 'react';
import classes from './SearchInput.module.css';
import { GoSearch } from 'react-icons/go';
import Input from '../Input/Input';

const SearchInput = ({
  state,
  setter,
  placeholder = 'Search here',
  onClick,
  variant = '',
  containerStyle = {},
  className,
  containerStyleIcon
}) => {
  return (
    <div
      className={[classes.inputWithSearch, className].join(' ')}
      data-variant={variant}
      style={containerStyle}>
      {variant == 'dashboard' && <GoSearch size={40} className={classes.icon} />}
      <Input
        value={state}
        setValue={setter}
        type={'text'}
        placeholder={placeholder}
        customStyle={{
          border: 'none',
          width: '100%'
        }}
        inputStyle={{
          border: 'none',
          paddingBlock: '11px'
        }}
        className={classes.inputContainer}
      />
      {variant !== 'dashboard' && (
        <GoSearch onClick={onClick} size={48} className={classes.icon} style={containerStyleIcon} />
      )}
    </div>
  );
};

export default SearchInput;
